
import { http } from "../http-common";

const getCroplist = (id) => {
  return http.get('/crop-stage');
};

const getCroplistWithCountry = (id) => {
  // return http.get('/crop-stage');
  return http.get('/crop-stage/crop-stage-drop-down');

};

const getmoduleregistration = (id) => {
  return http.get(`/module/${id}`);
};

const create = (data) => {
  return http.post("/module", data);
};

const updateModule = (data) => {
  return http.put(`/module`, data);
};
const updateSequence = (data) => {
  return http.put(`/module/sequence`, data);
};
const remove = (id) => {
  return http.delete(`/module/${id}`);
};

const getModuleDetails = async (moduleId) => {
  try {
    const response = await http.get(`/module/details?moduleId=${moduleId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const ModulesRegistration = {
  getmoduleregistration,
  getCroplist,
  create,
  updateModule,
  updateSequence,
  remove,
  getCroplistWithCountry,
  getModuleDetails
};

export default ModulesRegistration;
